import React from 'react';
import { MeasurementsSection, ResultsSection } from '../Sections';
import { AashtoPreparationSection, AashtoDryMassesSection } from './Sections';
import ids from '../../QestIds';
import { WorksheetRootComponent } from 'Components/Worksheets/Core';

const qestIds = [ids.moistureContent.AASHTO_T_265.rev2015];

let AashtoMeasuredMoistureContentWorksheet: WorksheetRootComponent = () => (
  <>
    <AashtoPreparationSection />
    <MeasurementsSection />
    <AashtoDryMassesSection />
    <ResultsSection />
  </>
);

AashtoMeasuredMoistureContentWorksheet.qestIds = qestIds;

export default AashtoMeasuredMoistureContentWorksheet;
export { AashtoMeasuredMoistureContentWorksheet };
